import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { PortalOnboarding } from "@/components/portal/portal-onboarding";
import { portalOnboardingQuery } from "@/lib/portal-data";

export const Route = createFileRoute("/portal/onboarding")({
  loader: ({ context }) => context.queryClient.ensureQueryData(portalOnboardingQuery),
  component: PortalOnboardingPage,
});

function PortalOnboardingPage() {
  const { data } = useQuery(portalOnboardingQuery);
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="font-heading font-semibold text-2xl tracking-tight">Onboarding</h1>
        <p className="text-muted-foreground text-sm">
          Your getting-started checklist. Tick off tasks as you complete them.
        </p>
      </div>
      <PortalOnboarding tasks={data ?? []} />
    </div>
  );
}
